module.exports = __webpack_public_path__ + "img/2.72a99ac.png";